import React, { Component } from 'react'
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { PaymentList } from '../../common/transactions';

import basketActions from '../../../actions/transactions/basket';
import purchaseActions from '../../../actions/transactions/purchases';
import addressActions from '../../../actions/transactions/address';

class CheckoutPage extends Component {

    componentDidMount() {
        const { getBasket, getProducts, getPackages, getPromotionPrices, basket } = this.props;

        const emailAddress = localStorage.getItem( "email_address" );

        if( !basket.products.length && !basket.packages.length ) browserHistory.push( `/basket` );

        getProducts();
        getPackages();
        getBasket();
        getPromotionPrices( emailAddress );
    };

    handlePayment() {
        const { createPayment, setPriceForBasket, basket, promotional_packages, promotional_products } = this.props;
        
        const hasPromPackage = Object.keys( promotional_packages ).length > 0 ? promotional_packages[0].redeemed === 0 : false,
              hasPromProduct = Object.keys( promotional_products ).length > 0 ? promotional_products[0].redeemed === 0 : false,
                   promotion = ( hasPromPackage || hasPromProduct ),
                   person_id = localStorage.getItem( 'person_id' ),
                       price = basket.total;

        if( promotion ) {
            setPriceForBasket( person_id, price, 1 );
        }

        createPayment();

		browserHistory.push( `/checkout/payment` );
    }

    render() {
        const { basket, all_packages, all_products, products, packages } = this.props;

        const _products = basket.products,
              _packages = basket.packages;

        const packagePrices = all_packages.map( p => {
            return {
                id: p.package_id,
                price: p.promotional_price,
            };
        } );

        const packageContent = packages.map( p => {
            return {
                id: p.id,
                name: p.name,
                group: p.group,
                description: p.description,
            };
        } );

        const productPrices = all_products.map( p => {
            return {
                id: p.product_id,
                price: p.promotional_price,
            };
        } );

        const productContent = products.map( p => {
            return {
                id: p.id,
                name: p.name,
                group: p.group,
                description: p.description,
            };
        } );

        return (
            <article className="container basket-body">
                <main>
                    <section className="row">
                        <div className="col-xs-12 text-center">
                            <h1 className="h1">Your Payment Information</h1>
                            <hr/>
                        </div>
                    </section>
                    <section className="row">
                        <div className="col-xs-12 col-lg-6">
                        </div>
                        <div className="col-xs-12 col-lg-6">
                            {
                                basket.products.length > 0 ?
                                    (
                                        <div className="">
                                            <h4 className="h4">Products</h4>
                                            <hr/>
                                            <PaymentList items={ _products } prices={ productPrices } content={ productContent }  />
                                            <hr/>
                                        </div>
                                    ) : null
                            }
                            {
                                basket.packages.length > 0 ?
                                (
                                    <div className="">
                                        <h4 className="h4">Packages</h4>
                                        <hr/>
                                        <PaymentList items={ _packages } prices={ packagePrices } content={ packageContent }  />
                                        <hr/>
                                    </div>
                                ) : null
                            }
                        </div>
                        <div className="col-xs-12">
                            <hr/>
                        </div>
                    </section>
                </main>
            </article>
        );
    };
}

const mapStateToProps = state => {
    return {
        basket: state.transactions.basket,
        products: state.transactions.products,
        packages: state.transactions.packages,
        addresses: state.transactions.addresses,
        all_packages: state.transactions.all_packages,
        all_products: state.transactions.all_products,
        promotional_packages: state.transactions.promotional_packages,
        promotional_products: state.transactions.promotional_products,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getBasket: () => dispatch( basketActions.getBasket() ),
        getProducts: () => dispatch( purchaseActions.getProducts() ),
        getPackages: () => dispatch( purchaseActions.getPackages() ),
        getPersonAddresses: personId => dispatch( addressActions.getPersonAddresses( personId ) ),
        setPriceForBasket: ( person_id, price, VAT ) => dispatch( basketActions.setPriceForBasket( person_id, price, VAT  ) ),
        createPayment: () => dispatch( basketActions.createPayment() ),
        getPromotionPrices: email => dispatch( purchaseActions.getPromotionPrices( email ) ),
    };
};

export default connect( mapStateToProps, mapDispatchToProps )( CheckoutPage );



// WEBPACK FOOTER //
// src/client/components/site/pages/CheckoutPage.js